export default __webpack_public_path__ + "static/media/choc_granola.cfe3a8bf.jpg";